// Don't apply 'HeadingBuilder' for this component's 'Tippy contents' (label fields with id, extra classes)
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShopperContext } from '../context/shopper';
import * as Constants from '../constants';
import { useForm } from "../hooks/useForm";
import TippyTipIcon from './TippyTipIcon';
import ShowAlert from '../components/ShowAlert';
import Checkbox from "../components/Checkbox";
import { ErrorList } from './ErrorList';
import HeadingBuilder from './HeadingBuilder';
import { TermsPrivacyUrls } from './pieces/TermsPrivacyUrls';
import { useTranslation } from "react-i18next";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const Signup = () => {
  const { signup, spAuthIsActive } = useContext(ShopperContext);
  const { errorsDoExist, dismissErrorsList, addToErrorsList } = useContext(ShopperContext);
  const { setErrorsDoExistToFalse, setErrorsDoExistToTrue } = useContext(ShopperContext);
  const [agreeTermsPrivacy, setAgreeTermsPrivacy] = useState(false);
  const [agreeMktgEmailTerms, setAgreeMktgEmailTerms] = useState(false);
  const [showConfirmYourEmailMsg, setShowConfirmYourEmailMsg] = useState(false);

  const navigate = useNavigate();
  const { t } = useTranslation();

  // TODO: maybe remove some of these, save them for entry in Profile update
  const initialState = {
    identifier: '',
    firstname: '',
    lastname: '',
    shortname: '',
    email: '',
    // image_url: '',
    // bio: '',
    postal_code: '',
    agree_tos_pp_a: false,
    password: '',
    password_confirmation: '',
    show_help_video_icons: true,
    show_tippy_help_alert_icons: true,
    mktg_email_optin: false,
    help_voice: Constants.TIPPY_HELP_VOICE,
  };
  const { formData, handleChange, reset, editFormValues } = useForm(initialState);

  const dismissConfirmEmailButton = () => {
    setShowConfirmYourEmailMsg(false);
  };

  const handleTermsPrivacyAgree = () => {
    const newTermsPrivacyValue = !agreeTermsPrivacy;
    setAgreeTermsPrivacy(newTermsPrivacyValue);
    handleChange({ target: {name: 'agree_tos_pp_a', value: newTermsPrivacyValue} });
  };

  const handleTermsPrivacyAgreeClick = () => {
    handleTermsPrivacyAgree();
  };

  const handleMktgEmailAgree = () => {
    const newEmailValue = !agreeMktgEmailTerms;
    setAgreeMktgEmailTerms(newEmailValue);
    handleChange({ target: {name: 'mktg_email_optin', value: newEmailValue} });
  };

  const handleEmailAgreeClick = () => {
    handleMktgEmailAgree();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log('signup formdata', formData)
    const configObj = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData })
    }

    dismissErrorsList();
    setErrorsDoExistToFalse();

    fetch('/api/signup', configObj)
    .then(res => res.json())
    .then(shopper => {
       if (!shopper.errors) {
          // console.log('fas saia', spAuthIsActive)
          if (spAuthIsActive) {
            setShowConfirmYourEmailMsg(true);
          } else {
            // signup(shopper)
            navigate('/')
          }
       } else {
           //reset()
           //const errorLis = shopper.errors.map(err => <li>{err}</li>)
           //const errorLis = shopper.errors.map(err => <li className="stdError" key={err} >{err}</li>)
           //setErrorsList(errorLis)

           console.log("api_signup error(s)", shopper);
           const errorLis = shopper.errors.map(err => <li className="stdError" key={err} >{err}</li>)
           // TODO: is "key={err}" reliably different? (is this sufficient?)

           //addToErrorsList(_errorsList => [ ..._errorsList, errorLis ])
           addToErrorsList( errorLis )
           setErrorsDoExistToTrue();
       }
    })
  }

  const [showTermsPrivacyTipAlert, setShowTermsPrivacyTipAlert] =useState(false)
  const toggleTermsPrivacyTipAlert =
                () =>  setShowTermsPrivacyTipAlert(! showTermsPrivacyTipAlert);

  const [showFnameTipAlert, setShowFnameTipAlert] = useState(false);
  const toggleFnameTipAlert = () =>  setShowFnameTipAlert(! showFnameTipAlert);
  const alertMessageFname =
    t('shopper.nameContext', {whichName: t('shopper.firstname.tippyContent')});

  const [showLnameTipAlert, setShowLnameTipAlert] = useState(false);
  const toggleLnameTipAlert = () =>  setShowLnameTipAlert(! showLnameTipAlert);
  const alertMessageLname =
    t('shopper.nameContext', {whichName: t('shopper.lastname.tippyContent')});

  const [showUnameTipAlert, setShowUnameTipAlert] = useState(false);
  const toggleUnameTipAlert = () =>  setShowUnameTipAlert(! showUnameTipAlert);

  const [showEmailTipAlert, setShowEmailTipAlert] = useState(false);
  const toggleEmailTipAlert = () =>  setShowEmailTipAlert(! showEmailTipAlert);

  const [showPwordTipAlert, setShowPwordTipAlert] = useState(false);
  const togglePwordTipAlert = () =>  setShowPwordTipAlert(! showPwordTipAlert);

  const [showPwConfTipAlert, setShowPwConfTipAlert] = useState(false);
  const togglePwConfTipAlert = () => setShowPwConfTipAlert(! showPwConfTipAlert)

  const [showMktgEmailTipAlert, setShowMktgEmailTipAlert] = useState(false);
  const toggleMktgEmailTipAlert =
                      () =>  setShowMktgEmailTipAlert(! showMktgEmailTipAlert);

  const mktgEmailTipAlert = t('shopper.mktgEmailOptin.tippyContent', {
                            takeAction: t('shopper.mktgEmailOptin.checkTheBox')
                          })
  // Because we respect your inbox, we only send account-specific alerts by default. If you would like to receive newsletter updates, usage advice, and exclusive offers, check the box to opt-in.  

  return (
    <div>
      <div className="container-fluid mt-5 ">
        <div className='signInBkgrnd' id="duotone_sign_up"></div>
        <div className="container mt-6 p-5">
          <h1 className="fs-1 white fw-light">
            { t('global.label.sign_up').toUpperCase() }
            {/* SIGN UP */}
          </h1>
          <p className='fs-3'>{ t('signup.tagline.line1') }<br />
                              { t('signup.tagline.line2') }
           {/* And tell EVERYBODY\n to join you in the savings! */}
          </p>
          <small>{
            (showConfirmYourEmailMsg && spAuthIsActive)
              ? null
              : t('signup.tagline.line13')
                // (Input fields with * are required.)
          }</small>
        </div>
       { (showConfirmYourEmailMsg && spAuthIsActive)
          ? <>
              <HeadingBuilder
                containerType  = 'h4'
                Size           = 'strong'
                headingText    = { t('signup.success.confirmYourEmailMsg') }
                // Success! Now please check your email for confirmation instructions.
                tippyAlertText = { t('signup.success.tippyContent') }
                tippyText      = { t('signup.success.tippyContent') }
                // We have emailed you with a link to verify your email address.
              />
              <HeadingBuilder
                headingText    = { t('signup.dismissConfirmButton.label') }
                // Click to Dismiss
                buttonAction   = {dismissConfirmEmailButton}
                tippyAlertText = { t('signup.dismissConfirmButton.tippyContent') }
                tippyText      = { t('signup.dismissConfirmButton.tippyContent') }
                // Click to dismiss this message and show the 'Sign Up' form again.
              />
              <br/>
            </>
          : 

        // show the Sign Up form
        <div className="container">
          <div className="row row-cols-1 d-flex justify-content-center">
            <form onSubmit={handleSubmit}>
              <div className="oneline-container-left">
                <Tippy content= { t('shopper.agreeTermsPrivacyA.termsPrivacy') } >
                {/* 'Terms' is the agreement between you and Festa ... */}
                  <label htmlFor="colFormLabelSm agree_tos_pp_a" className="col-sm-4 col-form-label text-end fw-bold"
                  >
                    <TermsPrivacyUrls />
                  </label>
                </Tippy>
                &nbsp;
                <TippyTipIcon
                  alertMessage={t('shopper.agreeTermsPrivacyA.tippyContent')}
                  alertIcon={Constants.GET_ICON_CIRCLE_HOOK}
                  showTippyAlert={showTermsPrivacyTipAlert}
                  forceShowAlertTextBoolean={true}
                  toggleTippyAlert={toggleTermsPrivacyTipAlert}
                />
                <ShowAlert showAlert={showTermsPrivacyTipAlert}
                  alertMsg={t('shopper.agreeTermsPrivacyA.tippyContent')}
                  // Click the checkbox to show your agreement with...
                />
                <div className="col-sm-6">
                  <Checkbox
                    key="5"
                    isChecked={agreeTermsPrivacy}
                    setIsChecked={handleTermsPrivacyAgreeClick}
                    label={t('shopper.agreeTermsPrivacyA.label')}
                    // I have read and agree to...
                  />
                </div>
                &nbsp;*
              </div>

              <div className="oneline-container-left">
                  <label htmlFor="colFormLabelSm firstname" className="col-sm-4 col-form-label text-end fw-bold"
                    id="colFormLabelSm">
                      {/* First Name: */}
                      { t('shopper.firstname.label') }
                  </label>
                &nbsp;
                <TippyTipIcon
                  alertMessage={alertMessageFname}
                  alertIcon={Constants.GET_ICON_CIRCLE_HOOK}
                  showTippyAlert={showFnameTipAlert}
                  forceShowAlertTextBoolean={true}
                  toggleTippyAlert={toggleFnameTipAlert}
                />
                <ShowAlert showAlert={showFnameTipAlert}
                  alertMsg={alertMessageFname}
                />
                <div className="col-sm-6">
                  <input
                    className="form-control form-control-sm"
                    key="10"
                    type="text"
                    id="firstname"
                    name="firstname"
                    placeholder={t('shopper.firstname.placeholder')}
                    autoComplete="given-name"
                    maxLength={Constants.NAME_MAX_LENGTH}  // 40
                    onChange={handleChange}
                    value={formData.firstname}
                    required
                  />
                </div>
                &nbsp;*
              </div>

              <div className="oneline-container-left">
                  <label htmlFor="colFormLabelSm lastname" className="col-sm-4 col-form-label text-end fw-bold"
                    >
                    { t('shopper.lastname.label') }
                    {/* Last Name: */}
                  </label>
                &nbsp;
                <TippyTipIcon
                  alertMessage={alertMessageLname}
                  alertIcon={Constants.GET_ICON_CIRCLE_HOOK}
                  showTippyAlert={showLnameTipAlert}
                  forceShowAlertTextBoolean={true}
                  toggleTippyAlert={toggleLnameTipAlert}
                />
                <ShowAlert showAlert={showLnameTipAlert}
                  alertMsg={alertMessageLname}
                />
                <div className="col-sm-6">
                  <input
                    className="form-control form-control-sm"
                    key="20"
                    type="text"
                    id="lastname"
                    name="lastname"
                    placeholder={t('shopper.lastname.placeholder')}
                    autoComplete="family-name"
                    maxLength={Constants.NAME_MAX_LENGTH}  // 40
                    onChange={handleChange}
                    value={formData.lastname}
                  />
                </div>
              </div>

              <div className="oneline-container-left">
                  <label htmlFor="colFormLabelSm identifier" className="col-sm-4 col-form-label text-end fw-bold"
                    >
                    { t('global.label.username') }
                    {/* Username */}
                  </label>
                &nbsp;
                <TippyTipIcon
                  alertMessage={t('shopper.identifier.tippyContent')}
                  alertIcon={Constants.GET_ICON_CIRCLE_HOOK}
                  showTippyAlert={showUnameTipAlert}
                  forceShowAlertTextBoolean={true}
                  toggleTippyAlert={toggleUnameTipAlert}
                />
                <ShowAlert showAlert={showUnameTipAlert}
                  alertMsg={t('shopper.identifier.tippyContent')}
                />
                <div className="col-sm-6">
                  <input
                    className="form-control form-control-sm"
                    key="30"
                    type="text"
                    style={{ textTransform: "lowercase" }}
                    id="identifier"
                    name="identifier"
                    autoComplete="username"
                    maxLength={Constants.IDENTIFIER_MAX_LENGTH}  // 30
                    onChange={handleChange}
                    value={formData.identifier}
                    required
                  />
                </div>
                &nbsp;*
              </div>

              <div className="oneline-container-left">
                  <label htmlFor="colFormLabelSm email" className="col-sm-4 col-form-label text-end fw-bold"
                  >
                    { t('shopper.email.label') }
                    {/* Email */}
                  </label>
                &nbsp;
                <TippyTipIcon
                  alertMessage={t('shopper.email.tippyContent')}
                  alertIcon={Constants.GET_ICON_CIRCLE_HOOK}
                  showTippyAlert={showEmailTipAlert}
                  forceShowAlertTextBoolean={true}
                  toggleTippyAlert={toggleEmailTipAlert}
                />
                <ShowAlert showAlert={showEmailTipAlert}
                  alertMsg={t('shopper.email.tippyContent')}
                />
                <div className="col-sm-6">
                  <input
                    className="form-control form-control-sm"
                    key="40"
                    type="text"
                    style={{ textTransform: "lowercase" }}
                    id="email"
                    name="email"
                    autoComplete="email"
                    maxLength={Constants.EMAIL_MAX_LENGTH}  // 60
                    onChange={handleChange}
                    value={formData.email}
                    required
                  />
                </div>
                &nbsp;*
              </div>

              <div className="oneline-container-left">
                  <label htmlFor="colFormLabelSm password" className="col-sm-4 col-form-label text-end fw-bold"
                  >
                    { t('shopper.password.label') }
                    {/* Password */}
                  </label>
                &nbsp;
                <TippyTipIcon
                  alertMessage={t('shopper.password.tippyContent')}
                  alertIcon={Constants.GET_ICON_CIRCLE_HOOK}
                  showTippyAlert={showPwordTipAlert}
                  forceShowAlertTextBoolean={true}
                  toggleTippyAlert={togglePwordTipAlert}
                />
                <ShowAlert showAlert={showPwordTipAlert}
                  alertMsg={t('shopper.password.tippyContent')}
                />
                <div className="col-sm-6">
                  <input
                    className="form-control form-control-sm"
                    key="50"
                    type="password"
                    id="password"
                    name="password"
                    autoComplete="new-password"
                    onChange={handleChange}
                    value={formData.password}
                    required
                  />
                </div>
                &nbsp;*
              </div>

              <div className="oneline-container-left">
                  <label htmlFor="colFormLabelSm password_confirmation" className="col-sm-4 col-form-label text-end fw-bold"
                  >
                    { t('shopper.password_confirmation.label') }
                    {/* Password Confirmation */}
                  </label>
                &nbsp;
                <TippyTipIcon
                  alertMessage={t('shopper.password_confirmation.tippyContent')}
                  alertIcon={Constants.GET_ICON_CIRCLE_HOOK}
                  showTippyAlert={showPwConfTipAlert}
                  forceShowAlertTextBoolean={true}
                  toggleTippyAlert={togglePwConfTipAlert}
                />
                <ShowAlert showAlert={showPwConfTipAlert}
                  alertMsg={t('shopper.password_confirmation.tippyContent')}
                />
                <div className="col-sm-6">
                  <input
                    className="form-control form-control-sm"
                    key="60"
                    type="password"
                    id="password_confirmation"
                    name="password_confirmation"
                    autoComplete="current-password"
                    onChange={handleChange}
                    value={formData.password_confirmation}
                    required
                  />
                </div>
                &nbsp;*
              </div>

            { false
              ?
              <div className="row mb-3">
                <Tippy content= { t('shopper.postal_code.tippyContent') } >
                  <label htmlFor="colFormLabelSm postal_code" className="col-sm-4 col-form-label text-end fw-bold"
                  >
                    { t('shopper.postal_code.label') }
                    {/* Zip/Postal Code */}
                  </label>
                </Tippy>&nbsp;
                <div className="col-sm-6">
                  <input
                    className="form-control form-control-sm"
                    key="80"
                    type="text"
                    id="postal_code"
                    name="postal_code"
                    autoComplete="postal-code"
                    onChange={handleChange}
                    value={formData.postal_code}
                  />
                </div>
              </div>
              : null
            }

              <div className="oneline-container-left">
                <label htmlFor="colFormLabelSm mktg_email_optin"
                       className="col-sm-4 col-form-label text-end fw-bold"
                >
                  { t('shopper.mktgEmailOptin.label') }
                  {/* Email Opt-in */}
                </label>
                &nbsp;
                <TippyTipIcon
                  alertMessage={mktgEmailTipAlert}
                  alertIcon={Constants.GET_ICON_CIRCLE_HOOK}
                  showTippyAlert={showMktgEmailTipAlert}
                  forceShowAlertTextBoolean={true}
                  toggleTippyAlert={toggleMktgEmailTipAlert}
                />
                <ShowAlert showAlert={showMktgEmailTipAlert}
                  alertMsg={mktgEmailTipAlert}
                />
                <div className="col-sm-6">
                  <Checkbox
                    key="90"
                    isChecked={agreeMktgEmailTerms}
                    setIsChecked={handleEmailAgreeClick}
                    label={t('shopper.mktgEmailOptin.description')}
              // Send me helpful advice, news, and exclusive offers (Optional).
                  />
                </div>
              </div>

              <br/>
              <div className="container">
                <div className="row row-cols-1 d-flex justify-content-center">
                  { errorsDoExist && <ErrorList /> }
                </div>
              </div>
              
              <input
                key="100"
                className="btn btn-primary"
                type='submit'
                value='Submit'
                disabled={
                  formData.identifier.trim().length === 0
                    ||
                  formData.email.trim().length === 0
                    ||
                  formData.password.trim().length === 0
                    ||
                  formData.password_confirmation.trim().length === 0
                }
              />
            </form>
          </div>
        </div>
       }
      </div>
    </div>
  )
}

export default Signup;
